import { useContext } from 'react';

import { TranslationContext } from 'context/translationContext';

import styles from './styles.module.scss';
import { Props } from './types';

const FloorSwitcher = ({
  onLowerFloorClick,
  onHigherFloorClick,
  currentFloor,
}: Props) => {
  const { t } = useContext(TranslationContext);

  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={onLowerFloorClick}>
        -
      </button>
      <span className={styles.label}>
        {currentFloor === 0
          ? t('groundFloor')
          : `${t('floor')} ${currentFloor}`}
      </span>
      <button className={styles.button} onClick={onHigherFloorClick}>
        +
      </button>
    </div>
  );
};

export default FloorSwitcher;
